import React from "react";
import {Card, List, Typography, Popover} from "antd";
import moment from "moment";
import {isNumber} from "lodash";
import {ListHeader, ListItemContainer} from "./CourierWalletPaymentsList.styles";
import JSONInput from "react-json-editor-ajrm";
import {InfoCircleOutlined} from "@ant-design/icons";
import {RetryPaymentAccountButton} from "../../retryInvoiceAccountButton/RetryPaymentAccountButton";
import {useStore} from "@vigo/hooks";
const {Text} = Typography;

export const CourierWalletPaymentsList = ({payments, onItemSelect, selectedItem, loading}) => {
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    return (
        <Card
            loading={loading}
            title={
                <ListHeader>
                    <span>Ödemeler</span>
                </ListHeader>
            }
            bodyStyle={{padding: "0px"}}
        >
            <List
                dataSource={payments || []}
                style={{height: "500px", overflow: "auto", padding: "24px"}}
                renderItem={item => {
                    const isSelected =
                        selectedItem && selectedItem?._id?.toString() === item._id.toString();

                    return (
                        <List.Item
                            style={{
                                padding: "24px",
                                cursor: "pointer",
                                backgroundColor: isSelected ? "#f0f0f0" : "transparent"
                            }}
                            onClick={() => onItemSelect(item._id)}
                        >
                            <ListItemContainer>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Text>
                                        <b>Ödeme ID</b> : {item?.paymentId}{" "}
                                        {!isAgency && (
                                            <Popover
                                                content={
                                                    <JSONInput
                                                        id="paymentInvoiceJSON"
                                                        placeholder={item}
                                                        theme="dark_mitsuketa_tribute"
                                                        width="auto"
                                                        height="auto"
                                                        viewOnly={true}
                                                        confirmGood={false}
                                                    />
                                                }
                                            >
                                                <InfoCircleOutlined />
                                            </Popover>
                                        )}
                                    </Text>
                                    <Text>
                                        <b>Oluşturulma Tarihi</b> :{" "}
                                        {item?.createdAt
                                            ? moment(item.createdAt).format("DD MMMM YYYY HH:mm")
                                            : ""}
                                    </Text>
                                    <Text>
                                        <b>Durum</b> : {item?.status}
                                    </Text>
                                    <div style={{justifyContent: "left"}}>
                                        {item?.status === "Hata Alındı" && (
                                            <RetryPaymentAccountButton
                                                invoiceId={item?.invoiceId}
                                            />
                                        )}
                                    </div>
                                </div>
                                <Text strong type={item.amount >= 0 ? "success" : "danger"}>
                                    {isNumber(item?.amount)
                                        ? item?.amount?.toLocaleString("tr-TR", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                          })
                                        : "-"}{" "}
                                    ₺
                                </Text>
                            </ListItemContainer>
                        </List.Item>
                    );
                }}
            />
        </Card>
    );
};
